export default __webpack_public_path__ + "static/media/lilian4.d5452fde.jpg";